export default "__VITE_ASSET__c23f746e__"